import { Box, Container, Grid, Typography } from '@mui/material';
import { ReactElement, useCallback, useEffect, useState } from 'react';

import {
  getCategories,
  getOrganizationProducts,
} from '@app/adapter/catalog-service';
import { ProductDetailCardList } from '@app/components/Product/ProductDetailCardList';
import { ProductDetails } from '@app/components/Product/ProductDetails';
import { Loading } from '@app/components/Shared/Loading';
import { theme } from '@app/theme';
import { CategoryType, Product } from '@app/types/catalog';

interface ProductDetailInfoProps {
  product: Product;
}

export function ProductDetailInfo({
  product,
}: ProductDetailInfoProps): ReactElement {
  const [categoryId, setCategoryId] = useState<string | null>(null);
  const [resultProducts, setResultProducts] = useState<Product[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchCategoryId = useCallback(async () => {
    try {
      const response = await getCategories();
      const propertyCategory = response.data.value.find(
        (category) => category.name === CategoryType.PROPERTY
      );
      setCategoryId(propertyCategory ? propertyCategory.id : null);
    } catch (error) {
      console.error('Failed to fetch categories', error);
    }
  }, []);

  const fetchProducts = useCallback(async () => {
    if (!categoryId) return;
    setIsLoading(true);
    try {
      const response = await getOrganizationProducts(
        product.organizationId,
        categoryId
      );
      setResultProducts(response.data.value);
    } catch (error) {
      console.error('Failed to fetch organization products', error);
    } finally {
      setIsLoading(false);
    }
  }, [product.organizationId, categoryId]);

  useEffect(() => {
    void fetchCategoryId();
  }, [fetchCategoryId]);

  useEffect(() => {
    void fetchProducts();
  }, [fetchProducts]);

  return (
    <>
      {!product ? (
        <Loading />
      ) : (
        <Box maxWidth="100vw">
          <Container
            sx={{
              maxWidth: '100% !important',
            }}
            disableGutters
          >
            <Grid container spacing={3}>
              <Grid item sx={{ width: '100%' }}>
                <ProductDetails product={product} isExhibition={true} />
                {isLoading ? (
                  <Loading />
                ) : (
                  resultProducts.length > 0 && (
                    <Box bgcolor={'white'} py={{ sm: 9, xs: 4 }} px={2}>
                      <Grid maxWidth={1040} mx="auto">
                        <Typography
                          width="100%"
                          bgcolor={theme.palette.blueAccent.main}
                          color="white"
                          px={{ sm: 2, xs: 1 }}
                          height={36}
                          fontWeight={600}
                          borderRadius={15}
                          display="flex"
                          alignItems="center"
                          variant="h6"
                        >
                          おすすめの分譲情報
                        </Typography>
                        <ProductDetailCardList
                          products={resultProducts}
                          initialVisibleItems={6}
                          isProperty={true}
                        />
                      </Grid>
                    </Box>
                  )
                )}
              </Grid>
            </Grid>
          </Container>
        </Box>
      )}
    </>
  );
}
